export default "__VITE_ASSET__DaLYa9Rk__"